import { useNavigate, useSearchParams } from "react-router-dom";
import { trackEvent } from "../utils/analytics";

export const CameraError: React.FC = () => {
  const nav = useNavigate();
  const [searchParams] = useSearchParams();

  const sessionId = searchParams.get("s");
  const tableNumber = searchParams.get("t");
  const venueCode = searchParams.get("v");

  const handleGoBack = () => {
    nav(`/photo?s=${sessionId}&t=${tableNumber}&v=${venueCode}`);
  };

  const handleChooseAvatar = () => {
    trackEvent({ gaEvent: "avatar_start" });
    nav(`/photo?s=${sessionId}&t=${tableNumber}&v=${venueCode}&avatar=true`);
  };

  return (
    <div className="pageContainer">
      <div className="logoContainer">
        <img src={"./img/es-logo.svg"} width="110px" alt="Electric Shuffle" />
      </div>
      <div className="contentCard">
        <div className="errorContainer">
          <div className="errorTitleText">We need to access the camera to add your game face! </div>
          <div className="errorText">Go back and grant permissions to continue</div>
          <div className="errorText">Camera not working? Why not select an avatar!</div>
          <button className="no-background chooseAvatarBtn" onClick={handleChooseAvatar}>
            Choose Avatar
          </button>
        </div>
      </div>
      <footer className="btn-container">
        <button className="button" onClick={handleGoBack}>
          back
        </button>
      </footer>
    </div>
  );
};
